// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"6f9169e0","549":"6cbbb436","630":"6cbbb436","950":"3177ec37"}[chunkId] + ".chunk.css";
};